import {
  businessInsCardPanelInfo,
  businessInsData
} from './BusinessInsProductData';
import './BusinessInsPrdt.scss';
import ProductPanel from '../../../components/panel/product/ProductPanel';
import CardPanel from '../../../components/panel/card/CardPanel';
import PageTitle from '@components/form/PageTitle';
import BusinessInsCovgs from './BusinessInsCovgs';

const BusinessInsuranceProduct = () => {
  return (
    <>
      <PageTitle>
        Business Insurance: Get a Business Owners Policy (BOP) Quote |
        Stillwater Insurance
      </PageTitle>
      <ProductPanel product={businessInsData} />
      <CardPanel cardData={businessInsCardPanelInfo} />
      <BusinessInsCovgs />
    </>
  );
};

export default BusinessInsuranceProduct;
